<template>
  <div class="content">
    <app-header></app-header>
    <div v-if="!whetherLogin" class="noLogin">
      <div class="msg">
        <h3>请先登录您的账户</h3>
        <p><router-link to="login">立即登录</router-link></p>
      </div>
    </div>
    <div v-if="whetherLogin" class="personal clearfix">
      <div class="personalNav fl">
        <div class="personalC"><p>个人中心</p></div>
        <p
          @click="changeNav('basicMsg')"
          :class="{ actived: checkedVal == 'basicMsg' }"
        >
          <span class="icon iconfont">&#xe60a;</span>基本信息
        </p>
        <p
          @click="changeNav('resume')"
          :class="{ actived: checkedVal == 'resume' }"
        >
          <span class="icon iconfont">&#xe606;</span>我的简历
        </p>
        <p
          @click="changeNav('delivery')"
          :class="{ actived: checkedVal == 'delivery' }"
        >
          <span class="icon iconfont">&#xe61d;</span>我的投递
        </p>
        <p
          @click="changeNav('password')"
          :class="{ actived: checkedVal == 'password' }"
        >
          <span class="icon iconfont">&#xe6d2;</span>修改密码
        </p>
        <p
          @click="changeNav('systemMsg')"
          :class="{ actived: checkedVal == 'systemMsg' }"
        >
          <i class="el-icon-s-tools"></i>系统消息
        </p>
      </div>
      <div class="personalContent fr">
        <!-- 基本信息 -->
        <div v-if="checkedVal == 'basicMsg'" class="myMsg">
          <p class="avatar">
            <img v-bind:src="avatarPhoto" alt="高校教师硕士博士科研招聘" /><label class="edit"
              ><input
                type="file"
                @change="uploadAvatar()"
                id="saveImage"
                name="myphoto"
              /><span class="icon iconfont">&#xe651;</span>编辑头像</label
            >
          </p>
          <p style="color: red">图片尺寸建议72*100</p>
          <p>
            <i><span class="importants">&lowast;</span>姓名：</i
            ><input v-model="pernalName" type="text" />
          </p>
          <p>
            <i><span class="importants">&lowast;</span>手机：</i
            ><input v-model="telPhone" maxlength="11" type="text" />
          </p>
          <p>
            <i><span class="importants">&lowast;</span>邮箱：</i
            ><input v-model="pernalEmail" type="text" />
          </p>
          <!-- <p><i><span class="importantsDiff"></span>通信地址：</i><input v-model = "address" type="text" /></p> -->
          <p class="btnSubmit"><span @click="saveBasic1()">保存修改</span></p>
        </div>
        <!-- 我的简历 -->
        <div v-if="checkedVal == 'resume'" class="myResume">
          <div class="bsicResume">
            <div class="myResumeBasicMsg">
              <p class="clearfix nameTitle">
                <span
                  >{{ pernalName }}
                  <span v-if="resumesex == '男'" class="icon iconfont"
                    >&#xe694;</span
                  >
                  <span v-if="resumesex == '女'" class="icon iconfont"
                    >&#xe616;</span
                  >
                </span>
              </p>
              <p>
                <span>生日：{{ birthday }}</span
                >|<span>政治面貌：{{ politicalStatus }}</span
                >|<span>民族：{{ nationality }}</span
                >|<span>婚否：{{ genders }}</span>
              </p>
              <p>
                <span>学历：{{ resumeEdiu }}</span
                >|<span>专业：{{ profession }}</span
                >|<span>外语：{{ languages }}</span
                >|<span>毕业院校：{{ graduated }}</span
                >|<span>职称：{{ jobTitle }}</span>
              </p>
              <p>
                <span>电话：{{ telPhone }}</span
                >|<span>邮箱：{{ pernalEmail }}</span
                >|<span
                  >地址：{{ address }}|<span>籍贯：{{ birthplace }}</span></span
                >
              </p>
              <p>
                <span>工资：{{ expectedSalary }}</span>
                <!-- <span>最快入职时间：{{entryTimes}}</span> -->
              </p>
              <!-- <p><span>意向职位：{{resumeWant}}</span></p>
       						<p class="experience"><span>{{resumeYear}}年工作经验</span>| <span>{{resumeEdiu}}</span> | <span>{{ages}}岁</span> | <span>{{resumesex}}</span></p>
       						<p class="contact"><span>联系电话：{{telPhone}}</span><span>电子邮箱：{{pernalEmail}}</span></p> -->
            </div>
            <div class="myResumeAva">
              <img v-bind:src="avatarPhoto" alt="科研人才网-国外博士科研人才招聘" />
              <p>
                <i class="fr" @click="editBasic"
                  ><span class="icon iconfont">&#xe651;</span>编辑</i
                >
              </p>
            </div>
          </div>
          <div class="moreResume">
            <h3 class="clearfix">
              <span><i></i>教育背景</span
              ><span class="fr" @click="editeduExperience"
                ><span class="icon iconfont">&#xe64b;</span>添加</span
              >
            </h3>
            <div
              class="eduExperience"
              v-for="(items, index) in educationList"
              :key="'index_' + index"
            >
              <p class="clearfix">
                {{ items.schoolName }} {{ items.education }} {{ items.major }}
                {{ items.researchDirection }} {{ items.cultureType }}
                <i class="fr modify" @click="modifyedu(items)"
                  ><span class="icon iconfont">&#xe651;</span>编辑</i
                >
                <span class="fr"
                  >{{ items.beginYeartime }}-{{ items.beginMonthtime }} /
                  {{ items.endYeartime }}-{{ items.endMonthtime }}</span
                >
              </p>
            </div>
            <h3 class="clearfix">
              <span><i></i>工作/实践经历</span
              ><span class="fr" @click="editworkExperience"
                ><span class="icon iconfont">&#xe64b;</span>添加</span
              >
            </h3>
            <div
              v-for="(items, index) in jobHistory"
              class="workExperience"
              :key="'index-' + index"
            >
              <h4 class="clearfix">
                {{ items.companyName
                }}<i class="fr modify" @click="modifywork(items)"
                  ><span class="icon iconfont">&#xe651;</span>编辑</i
                ><span class="fr"
                  >{{ items.beginYeartime }}-{{ items.beginMonthtime }} /
                  {{ items.endYeartime }}-{{ items.endMonthtime }}</span
                >
              </h4>
              <p>职位：{{ items.job }} <span></span></p>
              <p v-html="items.description"></p>
            </div>
            <h3 class="clearfix">
              <span><i></i>科研成果</span
              ><span
                class="fr"
                @click="
                  achievementsFlag = true;
                  showMask = true;
                "
                ><span class="icon iconfont">&#xe651;</span>编辑</span
              >
            </h3>
            <div class="workExperience">
              <p v-html="achievements" style="text-indent: 30px"></p>
            </div>
            <h3 class="clearfix">
              <span><i></i>技能与证书</span
              ><span
                class="fr"
                @click="
                  skillsCertificateFlag = true;
                  showMask = true;
                "
                ><span class="icon iconfont">&#xe651;</span>编辑</span
              >
            </h3>
            <div class="workExperience">
              <p v-html="skillsCertificate" style="text-indent: 30px"></p>
            </div>
            <h3 class="clearfix">
              <span><i></i>荣誉或奖励</span
              ><span
                class="fr"
                @click="
                  honorCertificateFlag = true;
                  showMask = true;
                "
                ><span class="icon iconfont">&#xe651;</span>编辑</span
              >
            </h3>
            <div class="workExperience">
              <p v-html="honorCertificate" style="text-indent: 30px"></p>
            </div>
            <h3 class="clearfix">
              <span><i></i>兴趣与特长</span
              ><span
                class="fr"
                @click="
                  interestAndExpertiseFlag = true;
                  showMask = true;
                "
                ><span class="icon iconfont">&#xe651;</span>编辑</span
              >
            </h3>
            <div class="workExperience">
              <p v-html="interestAndExpertise" style="text-indent: 30px"></p>
            </div>
          </div>
        </div>
        <!-- 投递记录 -->
        <div v-if="checkedVal == 'delivery'" class="myDelivery">
          <p class="deliveryTab clearfix">
            <span
              @click="checkView('true')"
              v-bind:class="{ checkViewFlag: checkViewFlags == 'true' }"
              >投递成功</span
            >
            <!-- <span @click = "checkView('false')" v-bind:class="{'checkViewFlag':checkViewFlags == 'false' }">被查看</span> -->
          </p>
          <div class="deliverySucess">
            <div
              class="companyMsg clearfix"
              v-for="items in applyNoreadList"
              :key="items.id"
            >
              <router-link
                :to="{
                  path: '/jobDetail',
                  query: { jobDetailId: items.recruitId },
                }"
                target="_blank"
              >
                <div class="positions fl">
                  <p class="positionsName clearfix">
                    <span class="fl">{{ items.title }}</span>
                  </p>
                </div>
                <div class="companyContent fl">
                  <div class="company">
                    <p class="companyName clearfix">
                      投递成功<span class="fr"
                        >&nbsp;&nbsp; 发布时间：{{
                          items.recruitCrateTime | formatDate
                        }}</span
                      >
                    </p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="page-bar" v-if="_self.all > 1">
            <ul class="clearfix">
              <li v-if="cur == 1"><a class="banclick">首页</a></li>
              <li v-if="cur > 1"><a v-on:click="firstClick()">首页</a></li>
              <li v-if="cur > 1">
                <a v-on:click="cur--, pageClick()">上一页</a>
              </li>
              <li v-if="cur == 1"><a class="banclick">上一页</a></li>
              <li
                v-for="index in indexs"
                v-bind:class="{ active: cur == index }"
                :key="index.id"
              >
                <a v-on:click="btnClick(index)">{{ index }}</a>
              </li>
              <li v-if="cur != all">
                <a v-on:click="cur++, pageClick()">下一页</a>
              </li>
              <li v-if="cur == all"><a class="banclick">下一页</a></li>
              <li v-if="cur != all"><a v-on:click="endClick()">尾页</a></li>
              <li v-if="cur == all"><a class="banclick">尾页</a></li>
              <li>
                <a
                  >共<i>{{ all }}</i
                  >页</a
                >
              </li>
            </ul>
          </div>
        </div>
        <!--  修改密码  -->
        <div v-if="checkedVal == 'password'" class="changePassword">
          <p>
            <span>登录账户：{{ telPhone }}</span>
          </p>
          <p>
            <input
              type="password"
              v-model="newPsd"
              placeholder="请输入新密码"
            />
          </p>
          <p>
            <input
              type="password"
              v-model="newPswAgin"
              placeholder="再次输入新密码"
            />
          </p>
          <p class="saveMsg"><span @click="savePassword">保存</span></p>
        </div>
        <!-- 系统消息 -->

        <div v-if="checkedVal == 'systemMsg'" class="myDelivery">
          <p class="deliveryTab clearfix">
            <span class="checkViewFlag">系统消息</span>
          </p>
          <div class="deliverySucess">
            <div
              class="systemMsg clearfix"
              v-for="items in systemMsgList"
              :key="items.id"
            >
              <div class="sysMsg">
                <p>{{ items.title }}</p>
                <div class="contentMsg">
                  <p>{{ items.abstracts }}</p>
                  {{ items.content }}
                </div>
              </div>
            </div>
          </div>
          <div class="page-bar" v-if="_self.all > 1">
            <ul class="clearfix">
              <li v-if="cur1 == 1"><a class="banclick">首页</a></li>
              <li v-if="cur1 > 1"><a v-on:click="firstClick1()">首页</a></li>
              <li v-if="cur1 > 1">
                <a v-on:click="cur--, pageClick1()">上一页</a>
              </li>
              <li v-if="cur1 == 1"><a class="banclick">上一页</a></li>
              <li
                v-for="index in indexs"
                v-bind:class="{ active: cur1 == index }"
                :key="index.id"
              >
                <a v-on:click="btnClick1(index)">{{ index }}</a>
              </li>
              <li v-if="cur1 != all1">
                <a v-on:click="cur1++, pageClick1()">下一页</a>
              </li>
              <li v-if="cur1 == all1"><a class="banclick">下一页</a></li>
              <li v-if="cur1 != all1"><a v-on:click="endClick1()">尾页</a></li>
              <li v-if="cur1 == all1"><a class="banclick">尾页</a></li>
              <li>
                <a
                  >共<i>{{ all }}</i
                  >页</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="showMask">
      <div class="editBasic clearfix" v-if="showEditBasic">
        <p class="title fl">
          <span>添加基本信息</span
          ><span class="icon iconfont" @click="coloseMask">&#xe608;</span>
        </p>
        <p class="fl">
          <span><i>*</i>姓名：</span><input v-model="pernalName" type="text" />
        </p>
        <!-- <p class="fl"><span><i>*</i>工作年限：</span><input v-model = "resumeYear" type="text" /></p> -->
        <p class="fl">
          <span><i>*</i>学历：</span><input v-model="resumeEdiu" type="text" />
        </p>
        <p class="birsday fl">
          <span><i>*</i>出生日期：</span>
          <date-picker
            v-model="birthday"
            lang="zh"
            format="YYYY-MM-DD"
          ></date-picker>
        </p>
        <p class="fl">
          <span>性别：</span>
          <label
            ><input
              v-model="resumesex"
              name="sex"
              type="radio"
              value="男"
            />男</label
          >
          <label
            ><input
              v-model="resumesex"
              name="sex"
              type="radio"
              value="女"
            />女</label
          >
        </p>
        <p class="fl">
          <span>政治面貌：</span><input v-model="politicalStatus" type="text" />
        </p>
        <p class="fl">
          <span>民族：</span><input v-model="nationality" type="text" />
        </p>
        <p class="fl">
          <span>籍贯：</span><input v-model="birthplace" type="text" />
        </p>
        <p class="fl">
          <span><i>*</i>婚否：</span>
          <label
            ><input
              name="genders"
              v-model="genders"
              type="radio"
              value="已婚"
            />已婚</label
          >
          <label
            ><input
              name="genders"
              v-model="genders"
              type="radio"
              value="未婚"
            />未婚</label
          >
        </p>
        <p class="fl">
          <span><i>*</i>毕业院校：</span
          ><input v-model="graduated" type="text" />
        </p>
        <p class="fl">
          <span><i>*</i>专业：</span><input v-model="profession" type="text" />
        </p>
        <p class="fl">
          <span><i>*</i>外语水平：</span
          ><input v-model="languages" type="text" />
        </p>
        <p class="fl">
          <span>职称：</span><input v-model="jobTitle" type="text" />
        </p>
        <p class="fl">
          <span><i>*</i>电话：</span><input v-model="telPhone" type="text" />
        </p>
        <p class="fl">
          <span><i>*</i>邮箱：</span><input v-model="pernalEmail" type="text" />
        </p>
        <p class="fl">
          <span><i>*</i>地址：</span><input v-model="address" type="text" />
        </p>
        <p class="fl">
          <span>期望月薪：</span><input v-model="expectedSalary" type="text" />
        </p>
        <!-- <p  class="fl"><span><i>*</i>最快入职时间：</span>
					<label><input name = "entryTime" v-model="entryTimes" type="radio" value = "立刻" />立刻</label>
					<label><input name = "entryTime" v-model="entryTimes" type="radio" value = "一周内" />一周内</label>
					<label><input name = "entryTime" v-model="entryTimes" type="radio" value = "一月内" />一月内</label>
				</p> -->
        <p class="saveCommon fl">
          <span @click="saveBasicResume1(1)">保存</span>
        </p>
      </div>
      <div class="edithuntingTitle" v-if="showThunting">
        <!-- <p class="title"><span>添加求职状态</span><span class="icon iconfont" @click = "coloseMask">&#xe608;</span></p>
				<p class="check">
					<label><input name = "status" type="radio" v-model = "ThuntingStatus" value = "离职立即到岗" />离职立即到岗</label>
					<label><input name = "status" type="radio" v-model = "ThuntingStatus"  value = "在职欲换工作"  />在职欲换工作</label>
					<label><input name = "status" type="radio" v-model = "ThuntingStatus"  value = "暂不考虑跳槽" />暂不考虑跳槽</label>
				</p>
				<p class="saveCommon"><span @click = "saveBasicResume">保存</span></p> -->
      </div>
      <div class="editWork" v-if="showWork">
        <!--编辑工作经历-->
        <p class="title">
          <span>添加工作经历</span
          ><span class="icon iconfont" @click="coloseMask">&#xe608;</span>
        </p>
        <div class="check">
          <p class="comMsg">
            <span>单位名称：</span
            ><input
              type="text"
              v-model="comName"
              placeholder="请输入单位名称"
            />
            <span>单位部门：</span
            ><input
              type="text"
              v-model="comdepartment"
              placeholder="请输入部门"
            />
          </p>
          <p class="comMsg">
            <span>职位：</span
            ><input v-model="comJob" type="text" placeholder="请输入职位" />
          </p>
          <p class="comMsg">
            <span>开始时间：</span
            ><date-picker
              v-model="comBeginTime"
              lang="zh"
              type="month"
              format="YYYY-MM"
            ></date-picker>
            <span>结束时间：</span
            ><date-picker
              v-model="comEndTime"
              lang="zh"
              type="month"
              format="YYYY-MM"
            ></date-picker>
          </p>
          <editor
            id="editor_id"
            height="300px"
            width="776px"
            :content="editorText"
            pluginsPath="/static/kindeditor/plugins/"
            :loadStyleMode="false"
            @on-content-change="onContentChange"
          >
          </editor>
        </div>
        <p class="saveCommon"><span @click="saveWork">保存</span></p>
      </div>
      <div
        class="editWork"
        style="height: 440px; margin-top: -220px"
        v-if="achievementsFlag"
      >
        <!--添加科研成果-->
        <p class="title">
          <span>添加科研成果</span
          ><span
            class="icon iconfont"
            @click="
              achievementsFlag = false;
              showMask = false;
            "
            >&#xe608;</span
          >
        </p>
        <div class="check">
          <!-- <el-input
						type="textarea"
						:rows="6"
						placeholder="请添加科研成果"
						v-model="achievements">
					</el-input> -->
          <editor
            id="editor_id"
            height="300px"
            width="776px"
            :content="achievements"
            pluginsPath="/static/kindeditor/plugins/"
            :loadStyleMode="false"
            @on-content-change="onContentChange1"
          >
          </editor>
        </div>
        <p class="saveCommon"><span @click="saveBasicResume1(2)">保存</span></p>
      </div>
      <div
        class="editWork"
        style="height: 440px; margin-top: -220px"
        v-if="skillsCertificateFlag"
      >
        <!--技能与证书-->
        <p class="title">
          <span>添加技能与证书</span
          ><span
            class="icon iconfont"
            @click="
              skillsCertificateFlag = false;
              showMask = false;
            "
            >&#xe608;</span
          >
        </p>
        <div class="check">
          <!-- <el-input
						type="textarea"
						:rows="6"
						placeholder="请添加技能与证书"
						v-model="skillsCertificate">
					</el-input> -->
          <editor
            id="editor_id"
            height="300px"
            width="776px"
            :content="skillsCertificate"
            pluginsPath="/static/kindeditor/plugins/"
            :loadStyleMode="false"
            @on-content-change="onContentChange2"
          >
          </editor>
        </div>
        <p class="saveCommon"><span @click="saveBasicResume1(2)">保存</span></p>
      </div>
      <div
        class="editWork"
        style="height: 440px; margin-top: -220px"
        v-if="honorCertificateFlag"
      >
        <!--荣誉与证书-->
        <p class="title">
          <span>添加荣誉与证书</span
          ><span
            class="icon iconfont"
            @click="
              honorCertificateFlag = false;
              showMask = false;
            "
            >&#xe608;</span
          >
        </p>
        <div class="check">
          <!-- <el-input
						type="textarea"
						:rows="6"
						placeholder="请添加荣誉与证书"
						v-model="honorCertificate">
					</el-input> -->
          <editor
            id="editor_id"
            height="300px"
            width="776px"
            :content="honorCertificate"
            pluginsPath="/static/kindeditor/plugins/"
            :loadStyleMode="false"
            @on-content-change="onContentChange3"
          >
          </editor>
        </div>
        <p class="saveCommon"><span @click="saveBasicResume1(2)">保存</span></p>
      </div>
      <div
        class="editWork"
        style="height: 440px; margin-top: -220px"
        v-if="interestAndExpertiseFlag"
      >
        <!--兴趣与特长-->
        <p class="title">
          <span>添加兴趣与特长</span
          ><span
            class="icon iconfont"
            @click="
              interestAndExpertiseFlag = false;
              showMask = false;
            "
            >&#xe608;</span
          >
        </p>
        <div class="check">
          <!-- <el-input
						type="textarea"
						:rows="6"
						placeholder="请添加荣誉与证书"
						v-model="interestAndExpertise">
					</el-input> -->
          <editor
            id="editor_id"
            height="300px"
            width="776px"
            :content="interestAndExpertise"
            pluginsPath="/static/kindeditor/plugins/"
            :loadStyleMode="false"
            @on-content-change="onContentChange4"
          >
          </editor>
        </div>
        <p class="saveCommon"><span @click="saveBasicResume1(2)">保存</span></p>
      </div>
      <!--自我评价-->
      <!-- <div class="editWork" v-if = "introductionFlag">
				<p class="title"><span>自我评价</span><span class="icon iconfont" @click = "introductionFlag = false;showMask=false">&#xe608;</span></p>
				<div class="check">
					<editor id="editor_id" height="300px" width="776px" :content="introduction"
						pluginsPath="/static/kindeditor/plugins/"
						:loadStyleMode="false"
						@on-content-change="onContentChange">
					</editor>
				</div>
				<p class="saveCommon"><span @click = "saveBasicResume1(2)">保存</span></p>
			</div> -->
      <div class="editEdu" v-if="showEdu">
        <!--编辑教育经历-->
        <p class="title">
          <span>添加教育经历</span
          ><span class="icon iconfont" @click="coloseMask">&#xe608;</span>
        </p>
        <p class="comMsg">
          <span>学校名称：</span
          ><input
            type="text"
            v-model="schoolName"
            placeholder="请输入学校名称"
          />
          <span>专业：</span
          ><input type="text" v-model="schoolProf" placeholder="请输入专业" />
        </p>
        <p class="comMsg">
          <span>研究方向：</span
          ><input
            type="text"
            v-model="researchDirection"
            placeholder="请输入研究方向"
          />
          <span>培养类型：</span
          ><input
            type="text"
            v-model="cultureType"
            placeholder="请输入培养类型"
          />
        </p>
        <p class="comMsg">
          <span>学历：</span>
          <select v-model="schoolEducation" name="" id="">
            <option value="初中及以下">初中及以下</option>
            <option value="中专/中技">中专/中技</option>
            <option value="高中">高中</option>
            <option value="大专">大专</option>
            <option value="本科">本科</option>
            <option value="硕士">硕士</option>
            <option value="博士">博士</option>
          </select>
        </p>
        <p class="comMsg">
          <span>开始时间：</span
          ><date-picker
            v-model="schoolBeginTime"
            lang="zh"
            type="month"
            format="YYYY-MM"
          ></date-picker>
          <span>结束时间：</span
          ><date-picker
            v-model="schoolEndTime"
            lang="zh"
            type="month"
            format="YYYY-MM"
          ></date-picker>
        </p>
        <p class="saveCommon"><span @click="saveEducation">保存</span></p>
      </div>
    </div>
    <div><app-footer></app-footer></div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import AppFooter from "../../components/common/footer.vue";
import AppHeader from "../../components/common/header1.vue";
import { get, postWithJson, form } from "@/api/services";
// import func from '../../../vue-temp/vue-editor-bridge'
export default {
  name: "personalCenter",
  components: { DatePicker, AppFooter, AppHeader },
  data() {
    return {
      whetherLogin: true,
      checkedVal: "basicMsg",
      user_id: "",
      sumeId: "",
      pernalName: "", //姓名
      telPhone: "", //手机号
      pernalEmail: "", //邮箱
      address: "", //通信地址
      politicalStatus: "", //政治面貌
      nationality: "", //民族
      birthplace: "", //籍贯
      genders: "未婚", //婚否
      graduated: "", //毕业院校
      profession: "", //专业
      languages: "", //外语水平
      jobTitle: "", //职称
      expectedSalary: "", //期待月薪
      // entryTimes:'',//最快入职时间
      achievements: "", //科研成果
      skillsCertificate: "", //技能与证书
      honorCertificate: "", //荣誉与证书
      interestAndExpertise: "", //兴趣与特长
      introduction: "", //自我评价
      avatarPhoto: require("../../assets/imgs/personAvatar.png"), //上传头像地址
      userName: "",
      checkViewFlags: "true",
      newPsd: "",
      newPswAgin: "",
      applyNoreadList: "", //已投简历
      applyreadList: "", //已读简历
      rId: "", //简历id
      showMask: false, //遮罩是否显示
      showEditBasic: false, //编辑基本信息
      showThunting: false, //编辑求职状态
      showDes: false, //编辑自我描述
      showWork: false, //编辑工作经历
      showEdu: false, //编辑教育经历
      achievementsFlag: false, //科研成果
      skillsCertificateFlag: false, //技能与证书
      honorCertificateFlag: false, //荣誉与证书
      interestAndExpertiseFlag: false, //兴趣与特长
      introductionFlag: false, //自我评价
      // ThuntingStatus:"",//求职状态value
      resumeName: "", //简历姓名

      jobList: [], //职位列表

      resumeWant: "", //求职意向
      // resumeYear:'0',//工作年限
      resumeEdiu: "", //简历学历
      certificate: "", //证书
      certificateNo: "", //证书号码
      ages: "", //年龄
      birthday: "",
      resumesex: "男", //简历性别
      jobHistory: "", //工作经历列表
      editorText: "", //工作经历
      WorkId: "", //工作经历id
      comName: "", //公司名称
      comdepartment: "", //公司部门
      comJob: "", //公司职位
      comBeginTime: "", //工作经历 开始时间
      comEndTime: "", //工作经历 结束时间
      educationList: "", //教育经历
      educationId: "", //教育经历id
      schoolName: "", //学校名称
      schoolProf: "", //专业
      researchDirection: "", //研究方向
      cultureType: "", //培养类型
      schoolEducation: "", //学历
      realName: "", //身份证姓名
      idcardNo: "", //身份证号
      schoolBeginTime: "", //开始时间
      schoolEndTime: "", //结束时间
      verifiedCard: 0, //身份认证是否通过
      // certsmList1:false,//已认证的列表
      // certsmList2:false,//已认证的列表
      // certsmList3:false,//已认证的列表
      // certsmList4:false,//已认证的列表
      // certsmList5:false,//已认证的列表
      all: 1, //总页数
      cur: 1, //当前页码
      all1: 1, //系统消息总页数
      cur1: 1, // 系统消息当前页码
      pageSize: 10,
      systemMsgList: "", //系统消息

      lang: {
        days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月",
        ],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days",
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range",
        },
      },
      // custom range shortcuts
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.time3 = [new Date(), new Date()];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
    };
  },

  created: function () {
    let _self = this;
    let telnumber = localStorage.getItem("_id");
    this.telPhone = telnumber;
  },
  mounted: function () {
    this.hasLogin();
    // this.routerChange();
    // this.getLogin();
    // let _id = sessionStorage.getItem('_id');
    // if(_id != "" && _id != null){
    // 	this.whetherLogin = true;
    // }
  },
  methods: {
    routerChange: function () {
      let _self = this;
      if (
        _self.$route.query.basicMsg != "" &&
        _self.$route.query.basicMsg != undefined
      ) {
        _self.checkedVal = _self.$route.query.basicMsg;
        _self.changeNav(_self.checkedVal);
      }
    },
    changeNav: function (msg) {
      let _self = this;
      _self.checkedVal = msg;
      let _id = localStorage.getItem("_id");
      _self.user_id = _id;
      //我的投递
      if (msg == "delivery") {
        _self.myCheckView();
      }
      //我的简历
      if (msg == "resume") {
        var reqData = { userId: localStorage.getItem("_userId") };
        postWithJson("front/resumeInfo/queryResumeInfo", reqData).then(
          function (response) {
            console.log(response);
            if (response.data.status) {
              let dataList = response.data.data;
              if (dataList === null) {
                return false;
              }
              // let _userId = dataList.userId;
              // sessionStorage.setItem('_userId', _userId);
              _self.sumeId = dataList.id;
              _self.graduated = dataList.school;
              _self.resumeEdiu = dataList.education;
              _self.birthday = dataList.birth;
              _self.avatarPhoto =
                dataList.photo || require("../../assets/imgs/personAvatar.png");
              _self.politicalStatus = dataList.politicalAppearance;
              _self.nationality = dataList.nation;
              _self.birthplace = dataList.nativePlace;
              _self.genders = dataList.maritalStatus;
              _self.address = dataList.address;
              _self.expectedSalary = dataList.hopeMoney;
              // _self.entryTimes = dataList.arrivalTime;
              _self.languages = dataList.foreignLanguages;
              _self.jobHistory = dataList.resumeWorkList;
              _self.educationList = dataList.resumeStudyList;
              _self.skillsCertificate = dataList.skillsCertificate;
              _self.achievements = dataList.achievements; //科研成果
              _self.honorCertificate = dataList.honorCertificate; //荣誉与证书
              _self.interestAndExpertise = dataList.interestAndExpertise; //兴趣与特长
            } else {
              _self.$message({
                message: response.data.message,
                type: "error",
              });
            }
          },
          function (response) {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        );
      }
      if (msg == "systemMsg") {
        this.getSysMsg();
      }
    },
    getSysMsg: function () {
      var _self = this;
      var reqData = { pageNum: _self.cur1, pageSize: _self.pageSize };
      postWithJson("front/systemMessage/list", reqData).then(
        function (response) {
          _self.systemMsgList = response.data.rows;
          _self.all1 = response.data.total;
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    myCheckView: function () {
      let _self = this;
      postWithJson("front/userRecruit/queryUserRecruit", {
        userId: localStorage.getItem("_userId"),
      }).then(
        function (response) {
          if (response.data.rows.length > 0) {
            _self.applyNoreadList = response.data.rows;
            console.log(_self.applyNoreadList);
          }

          // if(response.data.status){
          // 	console.log(response)
          // 	let _userId = response.data.data.id;
          // 	sessionStorage.setItem('_userId', _userId);
          // 	_self.pernalName = response.data.data.name;		//姓名
          // 	_self.pernalEmail = response.data.data.email; //邮箱
          // 	_self.avatarPhoto = response.data.data.photo == ""?require("../../assets/imgs/personAvatar.png"):response.data.data.photo;
          // 	console.log("13")
          // }else{
          // 	_self.$message.error(response.data.message);
          // }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    hasLogin: function () {
      //用户是否登录
      let _self = this;
      let userCoookie = this.getCookie("session_token");
      if (userCoookie == null || userCoookie == "") {
        this.$router.push({ path: "/login", query: { loginFlag: true } });
        return false;
      }
      let _id = localStorage.getItem("_id");
      _self.user_id = _id;
      if (_id == "" || _id == null || _id == undefined) {
        _self.$router.push({ path: "/login", query: { loginFlag: true } });
        return false;
      } else {
        var reqData = { tel: _id };
        postWithJson("front/user/getUserInfo", reqData).then(
          function (response) {
            if (response.data.status) {
              console.log(response);
              let _userId = response.data.data.id;
              localStorage.setItem("_userId", _userId);
              _self.pernalName = response.data.data.name; //姓名
              _self.pernalEmail = response.data.data.email; //邮箱
              _self.avatarPhoto =
                response.data.data.photo == ""
                  ? require("../../assets/imgs/personAvatar.png")
                  : response.data.data.photo;
            } else {
              _self.$message({
                message: response.data.message,
                type: "error",
              });
            }
          },
          function (response) {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        );
      }
    },
    saveBasic1() {
      //保存基本信息
      let _self = this;
      if (_self.pernalName == "") {
        _self.$message({
          message: "请输入姓名",
          type: "error",
        });
        return false;
      }
      let myregEmail =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (_self.pernalEmail == "" || !myregEmail.test(_self.pernalEmail)) {
        _self.$message({
          message: "请输入正确的邮箱地址！",
          type: "error",
        });
        return false;
      }
      let myreg = /^1\d{10}$/;
      if (!myreg.test(parseInt(_self.telPhone))) {
        _self.$message({
          message: "请输入正确的手机号！",
          type: "error",
        });
        return false;
      }
      var reqData = {
        userId: localStorage.getItem("_userId"),
        loginName: localStorage.getItem("_id"),
        name: _self.pernalName,
        email: _self.pernalEmail,
        tel: _self.telPhone,
        sex: "",
        photo: _self.avatarPhoto,
      };
      postWithJson("front/user/updateUserInfo", reqData).then(
        function (response) {
          if (response.data.status) {
            _self.$message({
              message: "信息保存成功",
              type: "success",
            });
          } else {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    uploadAvatar: function () {
      //头像上传
      let _self = this;
      let x = document.getElementById("saveImage").files[0];
      let params = new FormData(); //创建一个form对象
      params.append("file", x, x.name); //append 向form表单添加数据
      //添加请求头  通过form添加的图片和文件的格式必须是multipart/form-data
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      postWithJson("front/common/upload", params, config).then(
        function (response) {
          if (response.data.code == 0) {
            _self.avatarPhoto = response.data.url;
          } else {
            _self.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        },
        function (response) {
          _self.$message({
            message: response.data.msg,
            type: "error",
          });
        }
      );
    },
    saveBasic: function () {
      //保存基本信息
      let _self = this;
      if (_self.pernalName == "") {
        _self.$message({
          message: "请输入姓名",
          type: "error",
        });
      }
      let myregEmail =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (_self.myregEmail == "" || !myreg.test(_self.myregEmail)) {
        this.$message({
          message: "请输入正确的邮箱地址！",
          type: "warning",
        });
        return false;
      }
      let myreg = /^1\d{10}$/;
      if (!myreg.test(parseInt(_self.telPhone))) {
        _self.$message({
          message: "请输入正确的手机号！",
          type: "error",
        });
      }
      let theAvatarPhoto = "";
      _self.avatarPhoto == ""
        ? (theAvatarPhoto = "")
        : (theAvatarPhoto = _self.avatarPhoto);
      _self.$http
        .post("https://www.uncle119.com/api/user/update", {
          user_id: _self.user_id + "",
          city: "",
          country: "",
          email: _self.pernalEmail + "",
          headimgUrl: theAvatarPhoto + "",
          language: "",
          location: _self.address + "",
          nickName: _self.pernalName + "",
          openId: "",
          phone: _self.telPhone + "",
          privilege: "",
          province: "",
          sex: "",
        })
        .then(
          function (response) {
            if (response.body.code == 200) {
              _self.$layer.msg("保存成功！");
            } else {
              _self.$message({
                message: response.body.msg,
                type: "error",
              });
            }
          },
          function (response) {
            _self.$message({
              message: response.body.msg,
              type: "error",
            });
          }
        );
    },
    editBasic: function () {
      //我的简历 编辑基本信息
      let _self = this;
      _self.showMask = true;
      _self.showEditBasic = true;
    },
    editHunting: function () {
      //我的简历 求职状态
      let _self = this;
      _self.showMask = true;
      _self.showThunting = true;
    },
    /* editmyDescription:function(){ //我的简历 自我描述
			let _self = this;	
			_self.showMask = true;
			_self.showDes = true;
		}, */
    editworkExperience: function () {
      //我的简历 工作经历
      let _self = this;
      _self.showMask = true;
      _self.showWork = true;
      _self.WorkId = "";
    },
    editeduExperience: function () {
      //我的简历 教育经历
      let _self = this;
      _self.educationId = "";
      _self.showMask = true;
      _self.showEdu = true;
    },
    saveBasicResume1: function (val) {
      //保存基本信息
      let _self = this;
      //if(){}  如果简历id为空 提示先填写基本信息
      // let beginMonth = _self.comBeginTime.getMonth()+1;
      // let endMonth = _self.comEndTime.getMonth()+1;
      let birthday1;
      if (_self.birthday == "" && val == 1) {
        _self.$message({
          message: "请输入生日",
          type: "error",
        });
        return false;
      }
      if (_self.birthday.toString().indexOf("-") > 1) {
        birthday1 = _self.birthday;
      } else {
        let birMonth = _self.birthday.getMonth() + 1,
          birDay = _self.birthday.getDate();
        (birMonth + "").length < 2
          ? (birMonth = "0" + birMonth)
          : (birMonth = birMonth);
        (birDay + "").length < 2 ? (birDay = "0" + birDay) : (birDay = birDay);
        birthday1 =
          _self.birthday.getFullYear() + "-" + birMonth + "-" + birDay;
      }

      if (_self.graduated == "" && val == 1) {
        _self.$message({
          message: "请输入毕业院校",
          type: "error",
        });
        return false;
      }
      if (_self.resumeEdiu == "" && val == 1) {
        _self.$message({
          message: "请输入学历",
          type: "error",
        });
        return false;
      }
      if (_self.address == "" && val == 1) {
        _self.$message({
          message: "请输入地址",
          type: "error",
        });
        return false;
      }
      if (_self.languages == "" && val == 1) {
        _self.$message({
          message: "请输入外语水平",
          type: "error",
        });
        return false;
      }
      if (_self.profession == "" && val == 1) {
        _self.$message({
          message: "请输入专业",
          type: "error",
        });
        return false;
      }
      // profession
      let sumeId = _self.sumeId ? _self.sumeId : "";
      let _userId = localStorage.getItem("_userId");
      let reqData = {
        id: sumeId, //简历id
        positionName: "", //职业名称
        school: _self.graduated, //
        education: _self.resumeEdiu, //
        birth: birthday1, //
        photo: "", //
        politicalAppearance: _self.politicalStatus, //
        nation: _self.nationality, //
        nativePlace: _self.birthplace, //
        maritalStatus: _self.genders, //
        address: _self.address, //
        hopeMoney: _self.expectedSalary, //
        // arrivalTime:_self.entryTimes,//
        foreignLanguages: _self.languages, //外语
        achievements: _self.achievements, //科研成果
        skillsCertificate: _self.skillsCertificate, //技能与证书
        honorCertificate: _self.honorCertificate, //荣誉与证书
        interestAndExpertise: _self.interestAndExpertise, //兴趣与特长
        introduction: _self.introduction, //自我评价
        userId: _userId, //用户表主键
      };
      postWithJson("front/resumeInfo/addorUpdate", reqData).then(
        function (response) {
          if (response.data.status) {
            let sumeId = response.data.data.id;
            _self.sumeId = sumeId;
            _self.birthday = response.data.data.birth;
            _self.showEditBasic = false;
            _self.showMask = false;
            _self.achievementsFlag = false; //科研成果
            _self.skillsCertificateFlag = false; //技能与证书
            _self.honorCertificateFlag = false; //荣誉与证书
            _self.interestAndExpertiseFlag = false; //兴趣与特长
            _self.introductionFlag = false; //自我评价
          } else {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    saveWork: function () {
      //保存工作经历
      let _self = this;
      if (_self.sumeId == "") {
        _self.$message({
          message: "请先填写基本信息！",
          type: "error",
        });
        return false;
      }
      let beginMonth = _self.comBeginTime.getMonth() + 1;
      let endMonth = _self.comEndTime.getMonth() + 1;
      (beginMonth + "").length < 2
        ? (beginMonth = "0" + beginMonth)
        : (beginMonth = beginMonth);
      (endMonth + "").length < 2
        ? (endMonth = "0" + endMonth)
        : (endMonth = endMonth);
      postWithJson("front/resumeWork/addorUpdate", {
        id: _self.WorkId,
        resumeId: _self.sumeId,
        department: _self.comdepartment + "",
        job: _self.comJob + "",
        companyName: _self.comName + "",
        beginYeartime: _self.comBeginTime.getFullYear() + "",
        endYeartime: _self.comEndTime.getFullYear() + "",
        beginMonthtime: beginMonth + "",
        endMonthtime: endMonth + "",
        description: _self.editorText + "",
      }).then(
        function (response) {
          if (response.data.status) {
            _self.showMask = false; //遮罩是否显示
            _self.showEditBasic = false;
            _self.showThunting = false;
            _self.showDes = false;
            _self.showWork = false;
            _self.showEdu = false;
            _self.achievementsFlag = false; //科研成果
            _self.skillsCertificateFlag = false; //技能与证书
            _self.honorCertificateFlag = false; //荣誉与证书
            _self.interestAndExpertiseFlag = false; //兴趣与特长
            _self.introductionFlag = false; //自我评价
            _self.changeNav("resume");
            _self.$message({
              message: "信息保存成功",
              type: "success",
            });
          } else {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    saveEducation: function () {
      //保存教育经历
      let _self = this;
      if (_self.sumeId == "") {
        _self.$message({
          message: "请先填写基本信息！",
          type: "error",
        });
        return false;
      }
      let beginMonth = _self.schoolBeginTime.getMonth() + 1;
      let endMonth = _self.schoolEndTime.getMonth() + 1;
      (beginMonth + "").length < 2
        ? (beginMonth = "0" + beginMonth)
        : (beginMonth = beginMonth);
      (endMonth + "").length < 2
        ? (endMonth = "0" + endMonth)
        : (endMonth = endMonth);
      postWithJson("front/resumeStudy/addorUpdate", {
        id: _self.educationId,
        resumeId: _self.sumeId,
        beginYeartime: _self.schoolBeginTime.getFullYear() + "",
        beginMonthtime: beginMonth,
        endYeartime: _self.schoolEndTime.getFullYear() + "",
        endMonthtime: endMonth,
        education: _self.schoolEducation + "",
        schoolName: _self.schoolName + "",
        major: _self.schoolProf + "",
        researchDirection: _self.researchDirection,
        cultureType: _self.cultureType,
      }).then(
        function (response) {
          if (response.data.status) {
            _self.showMask = false; //遮罩是否显示
            _self.showEditBasic = false;
            _self.showThunting = false;
            _self.showDes = false;
            _self.showWork = false;
            _self.showEdu = false;
            _self.achievementsFlag = false; //科研成果
            _self.skillsCertificateFlag = false; //技能与证书
            _self.honorCertificateFlag = false; //荣誉与证书
            _self.interestAndExpertiseFlag = false; //兴趣与特长
            _self.introductionFlag = false; //自我评价
            _self.changeNav("resume");
            _self.$message({
              message: "信息保存成功",
              type: "success",
            });
          } else {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    idcardNoSub: function () {
      //身份认证
      let _self = this;
      postWithJson("https://www.uncle119.com/api/verified/user", {
        user_id: _self.user_id,
        idcardNo: _self.idcardNo,
        realName: _self.resumeName,
      }).then(
        function (response) {
          if (response.body.code == 200) {
            _self.$layer.msg("您的身份证信息已提交成功");
          } else {
            _self.$layer.msg(response.body.msg);
          }
        },
        function (response) {
          _self.$layer.msg(response.body.msg);
        }
      );
    },
    subCertificate: function () {
      //证书认证
      let _self = this;
      let myreg = /^1\d{16}$/;
      if (_self.certificate == "") {
        this.$layer.msg("请选择证件类型！");
        return false;
      }
      if (!myreg.test(parseInt(_self.phone))) {
        this.$layer.msg("证件号码输入有误！");
        return false;
      }

      _self.$http
        .post("https://www.uncle119.com/api/verified/certificate", {
          user_id: _self.user_id,
          id: 0,
          certificateNo: _self.certificateNo + "",
          certificateName: _self.certificate + "",
          certificateLevel: "",
        })
        .then(
          function (response) {
            if (response.body.code == 200) {
              console.log(response.body);
              _self.$layer.msg("证书认证正在审核，审核通过后即可开始求职！");
            } else {
              _self.$layer.msg(response.body.msg);
            }
          },
          function (response) {
            _self.$layer.msg(response.body.msg);
          }
        );
    },
    onContentChange(val) {
      this.editorText = val;
    },
    onContentChange1(val) {
      this.achievements = val;
    },
    onContentChange2(val) {
      console.log(val.toString().length);
      if (val.toString().length > 2000) {
        this.$message({
          message: "长度超出限制，请重新输入",
          type: "error",
        });
      }
      this.skillsCertificate = val;
    },
    onContentChange3(val) {
      if (val.toString().length > 2000) {
        this.$message({
          message: "长度超出限制，请重新输入",
          type: "error",
        });
      }
      this.honorCertificate = val;
    },
    onContentChange4(val) {
      if (val.toString().length > 2000) {
        this.$message({
          message: "长度超出限制，请重新输入",
          type: "error",
        });
      }
      this.interestAndExpertise = val;
    },
    savePassword: function () {
      //修改密码
      let _self = this;
      if (_self.newPsd == "") {
        _self.$message({
          message: "请输入新密码!",
          type: "error",
        });
        return false;
      } else if (_self.newPswAgin == "") {
        _self.$message({
          message: "请再次输入新密码!",
          type: "error",
        });
        return false;
      } else if (_self.newPsd != _self.newPswAgin) {
        _self.$message({
          message: "密码输入不一致,请重新输入！!",
          type: "error",
        });
        return false;
      } else {
        let reqData = {
          receiveMan: _self.telPhone,
          userType: 1,
          newPassWord: _self.newPsd,
        };
        postWithJson("front/user/updatePassWord", reqData).then(
          function (response) {
            if (response.data.status) {
              localStorage.setItem("_token", "");
              localStorage.setItem("_id", "");
              _self.$message({
                message: "修改成功，请登录",
                type: "success",
              });
              _self.$router.push({ path: "/login" });
            } else {
              _self.$message({
                message: response.data.message,
                type: "error",
              });
            }
          },
          function (response) {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        );
      }
    },
    coloseMask: function () {
      var _self = this;
      _self.showMask = false;
      _self.showEditBasic = false;
      _self.showThunting = false;
      _self.showDes = false;
      _self.showWork = false;
      _self.showEdu = false;
      _self.achievementsFlag = false; //科研成果
      _self.skillsCertificateFlag = false; //技能与证书
      _self.honorCertificateFlag = false; //荣誉与证书
      _self.interestAndExpertiseFlag = false; //兴趣与特长
      _self.introductionFlag = false; //自我评价
    },

    firstClick: function () {
      this.cur = 1;
      this.myCheckView();
    },
    checkView: function (flags) {
      this.checkViewFlags = flags;
      this.myCheckView();
    },
    btnClick: function (data) {
      //页码点击事件
      if (data != this.cur) {
        this.cur = data;
        this.myCheckView();
      }
    },
    firstClick1: function () {
      this.cur = 1;
      this.getSysMsg();
    },
    checkView1: function (flags) {
      this.getSysMsg();
    },
    btnClick1: function (data) {
      //页码点击事件
      if (data != this.cur) {
        this.cur = data;
        this.getSysMsg();
      }
    },
    pageClick1: function () {
      this.getSysMsg();
    },
    endClick1: function () {
      this.cur = this.all;
      this.getSysMsg();
    },
    modifywork: function (items) {
      //编辑工作经历
      let _self = this;
      _self.showMask = true;
      _self.showWork = true;
      _self.WorkId = items.id;
      _self.comName = items.companyName;
      _self.comdepartment = items.department;
      _self.comJob = items.job;
      _self.editorText = items.description;
      _self.comBeginTime = new Date(
        items.beginYeartime + "-" + items.beginMonthtime + "-" + "01"
      );
      _self.comEndTime = new Date(
        items.endYeartime + "-" + items.endMonthtime + "-" + "01"
      );
    },
    modifyedu: function (items) {
      //编辑教育经历
      let _self = this;
      _self.showMask = true;
      _self.showEdu = true;
      _self.schoolName = items.schoolName;
      _self.schoolProf = items.major;
      _self.schoolEducation = items.education;
      (_self.researchDirection = items.researchDirection),
        (_self.cultureType = items.cultureType);
      _self.schoolBeginTime = new Date(
        items.beginYeartime + "-" + items.beginMonthtime + "-" + "01"
      );
      _self.schoolEndTime = new Date(
        items.endYeartime + "-" + items.endMonthtime + "-" + "01"
      );
      _self.educationId = items.id;
    },
    pageClick: function () {
      this.myCheckView();
    },
    endClick: function () {
      this.cur = this.all;
      this.myCheckView();
    },
  },
  computed: {
    indexs: function () {
      var left = 1;
      var right = this.all;
      var ar = [];
      if (this.all >= 5) {
        if (this.cur > 3 && this.cur < this.all - 2) {
          left = this.cur - 2;
          right = this.cur + 2;
        } else {
          if (this.cur <= 3) {
            left = 1;
            right = 5;
          } else {
            right = this.all;
            left = this.all - 4;
          }
        }
      }
      while (left <= right) {
        ar.push(left);
        left++;
      }
      return ar;
    },
  },
  filters: {
    formatDate: function (value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();
      return (
        year +
        "/" +
        month +
        "/" +
        day +
        " " +
        Hours +
        ":" +
        Minutes +
        ":" +
        Seconds
      );
    },
  },
  watch: {
    // $route (to,from){
    // 	if(to.query.basicMsg != from.query.basicMsg){
    // 		this.routerChange();
    // 	}
    // }
  },
};
</script>

<style lang = "less"  scoped="scoped">
//滚动条
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f1f1f1;
}

//滚动条轨道
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #f1f1f1;
  -moz-box-shadow: inset 0 0 6px #f1f1f1;
  box-shadow: inset 0 0 6px #f1f1f1;
  background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #c1c1c1;
  -moz-box-shadow: inset 0 0 6px #c1c1c1;
  box-shadow: inset 0 0 6px #c1c1c1;
  border-radius: 3px;
  background-color: #c1c1c1;
}
.page-bar {
  margin: 40px 0;
}
.page-bar ul {
  text-align: center;
}
.page-bar ul,
li {
  margin: 0px;
  padding: 0px;
}
.page-bar li {
  display: inline-block;
  list-style: none;
  margin: 0 4px;
}
.page-bar li:first-child > a {
  margin-left: 0px;
}
.page-bar a {
  border: 1px solid #ddd;
  text-decoration: none;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #848484;
  cursor: pointer;
}
.page-bar a:hover {
  background-color: #eee;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #1787fb;
  border-color: #1787fb;
}
.page-bar i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}
.mx-panel-month .cell {
  width: 30% !important;
  text-align: center !important;
}
.mx-panel-year {
  overflow-y: scroll;
}
.mx-panel-year .cell {
  width: 40% !important;
}
.checkViewFlag {
  background-color: white;
}
.content {
  width: 100%;
  min-height: 740px;
  position: relative;
  background-color: #f8f9fc;

  .noLogin {
    position: absolute;
    width: 329px;
    height: 376px;
    left: 50%;
    top: 50%;
    margin-top: -188px;
    margin-left: -164px;
    /* background: url(../../assets/images/119logo.png); */
    .msg {
      width: 297px;
      height: 150px;
      position: absolute;
      top: 14px;
      right: -220px;
      /* background: url(../../assets/images/msg.png); */
      h3 {
        font-size: 24px;
        color: #2b2b2b;
        margin-left: 62px;
        margin-top: 24px;
      }
      a {
        display: inline-block;
        width: 160px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: white;
        background-color: #1787fb;
        margin-left: 82px;
        margin-top: 10px;
      }
      a:hover {
        background-color: rgba(23, 135, 251, 0.8);
      }
    }
  }
  .personal {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    .personalNav {
      width: 154px;
      height: 292px;
      background-color: white;
      border: 1px solid #ebebed;
      box-sizing: border-box;
      .personalC {
        background: url(../../assets/imgs/personalCneter.png) center center
          no-repeat;
        height: 70px;
        p {
          height: 70px;
          line-height: 70px;
          color: white;
          text-align: center;
          font-size: 22px;
        }
      }
      p {
        height: 44px;
        line-height: 44px;
        border-left: 2px solid transparent;
        cursor: pointer;
        font-size: 14px;
        color: #444;
        .icon {
          display: inline-block;
          width: 54px;
          text-align: center;
        }
        i {
          display: inline-block;
          width: 54px;
          text-align: center;
          font-size: 20px;
        }
      }
      p.actived {
        border-left: 2px solid #1787fb;
        color: #1787fb;
      }
    }
    .importants {
      color: red;
      margin-right: 4px;
    }
    .importantsDiff {
      margin-right: 10px;
    }
    .personalContent {
      width: 1024px;
      min-height: 620px;
      background-color: white;
      .myMsg {
        padding-top: 52px;
        width: 520px;
        margin: 0 auto;
        p {
          color: #444;
          font-size: 14px;
          height: 64px;
          line-height: 64px;
          i {
            display: inline-block;
            width: 110px;
            font-style: normal;
          }
          input {
            width: 400px;
            height: 44px;
            line-height: 44px;
            border: none;
            background-color: #f8f8f8;
            font-size: 18px;
            text-indent: 10px;
          }
        }
        .avatar {
          text-align: center;
          vertical-align: top;
          height: 100px;
          .edit {
            vertical-align: top;
            color: #1787fb;
            font-size: 16px;
            cursor: pointer;
            height: 24px;
            margin-left: 30px;
            line-height: 24px;
            .icon {
              vertical-align: top;
              margin-top: 5px;
            }
            input {
              visibility: hidden;
              width: 0;
            }
          }
          img {
            width: 72px;
            height: 100px;
          }
        }
        .btnSubmit {
          text-align: center;
          span {
            display: inline-block;
            width: 282px;
            height: 54px;
            text-align: center;
            line-height: 54px;
            background-color: #1787fb;
            color: white;
            font-size: 20px;
            margin-top: 20px;
            margin-left: 80px;
            cursor: pointer;
          }
        }
      }
      .myResume {
        .bsicResume {
          background-color: #fff;
          height: 230px;
          box-sizing: border-box;
          padding-top: 40px;
          margin: 0 111px;
          .myResumeAva {
            display: inline-block;
            vertical-align: top;
            margin: 0 24px 0 58px;
            img {
              width: 70px;
              height: 100px;
            }
            i {
              color: #1787fb;
              cursor: pointer;
              font-style: normal;
              vertical-align: middle;
              margin-top: 44px;
              .iconfont {
                color: #1787fb;
                font-size: 18px;
                vertical-align: top;
                margin-right: 4px;
              }
            }
          }
          .myResumeBasicMsg {
            width: 640px;
            display: inline-block;
            padding-left: 20px;
            p {
              font-size: 14px;
              color: #444;
              height: 36px;
              line-height: 36px;
              span {
                margin: 0 4px;
              }
            }
            .experience {
              span {
                margin-right: 4px;
              }
            }
            .contact {
              span {
                margin-right: 52px;
              }
            }
            .nameTitle {
              span {
                font-size: 24px;
                color: #444;
                font-weight: bold;
                .iconfont {
                  display: inline-block;
                  width: 26px;
                  height: 26px;
                  line-height: 26px;
                  text-align: center;
                  background-color: #7ca0f5;
                  font-size: 16px;
                  color: white;
                  border-radius: 4px;
                  margin-left: 10px;
                }
              }
              .certificateNameLogo {
                vertical-align: middle;
                display: inline-block;
                width: 26px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                font-size: 12px;
                margin-left: 4px;
                border-radius: 4px;
                color: white;
                position: relative;
                img {
                  width: 26px;
                  height: 26px;
                }
                .tips {
                  position: absolute;
                  bottom: -44px;
                  font-size: 12px;
                  border-radius: 4px;
                  width: 160px;
                  line-height: 30px;
                  height: 30px;
                  left: -68px;
                  display: none;
                  background-color: bisque;
                  .theBlockquote {
                    position: absolute;
                    top: -16px;
                    left: 50%;
                    margin-left: -8px;
                    width: 0;
                    height: 0;
                    border-left: 10px solid transparent;
                    border-right: 10px solid transparent;
                    border-bottom: 20px solid bisque;
                  }
                }
              }
              .certificateNameLogo:hover .tips {
                display: block;
              }
            }
          }
        }
        .moreResume {
          padding: 0 111px 20px;
          box-sizing: border-box;
          h3 {
            font-size: 20px;
            color: #666666;
            height: 54px;
            line-height: 54px;
            border-top: 1px solid #e5e5e5;
            margin-top: 18px;
            span {
              vertical-align: middle;
            }
            i {
              vertical-align: middle;
              display: inline-block;
              height: 20px;
              width: 2px;
              background-color: #1787fb;
              margin-right: 14px;
              margin-top: -4px;
            }
            .fr {
              color: #1787fb;
              font-size: 16px;
              font-weight: normal;
              cursor: pointer;
              .iconfont {
                font-size: 24px;
                margin-right: 4px;
              }
            }
          }
          .huntingSatus {
            P {
              text-indent: 20px;
              line-height: 30px;
            }
          }
          .myDescription {
            p {
              text-indent: 20px;
              line-height: 30px;
            }
          }
          .workExperience {
            font-size: 16px;
            color: #444;
            p {
              line-height: 30px;
            }
            .fr {
              font-weight: normal;
            }
          }
          .eduExperience {
            padding-bottom: 30px;
            /* border-bottom: 1px solid #ddd; */
            p {
              text-indent: 20px;
              line-height: 30px;
            }
          }
          .authentication {
            padding-bottom: 40px;
            .inputvauthentication {
              input {
                width: 400px;
                height: 44px;
                border: none;
                background-color: #f8f8f8;
                margin-left: 20px;
                text-indent: 10px;
                font-size: 16px;
              }
              span {
                display: inline-block;
                width: 104px;
                text-align: center;
                height: 44px;
                line-height: 44px;
                color: white;
                background-color: #1787fb;
                font-size: 16px;
                margin-left: 10px;
                cursor: pointer;
                letter-spacing: 6px;
              }
            }
          }
          .documentCertification {
            padding-bottom: 40px;
            p {
              select {
                height: 40px;
                width: 180px;
                border: none;
                background-color: #f8f8f8;
                margin-left: 20px;
                text-indent: 10px;
              }
              input {
                width: 300px;
                height: 44px;
                border: none;
                background-color: #f8f8f8;
                margin-left: 10px;
                text-indent: 10px;
                font-size: 16px;
              }
              select {
                font-size: 16px;
              }
              span {
                display: inline-block;
                width: 104px;
                text-align: center;
                height: 44px;
                line-height: 44px;
                color: white;
                background-color: #1787fb;
                font-size: 16px;
                margin-left: 10px;
                cursor: pointer;
                letter-spacing: 6px;
              }
            }
            .hasCertification {
              text-indent: 20px;
              font-size: 16px;
              height: 24px;
              line-height: 24px;
              i {
                font-style: normal;
                color: #1787fb;
                margin-left: 10px;
              }
            }
          }
        }
      }
      .myDelivery {
        .deliveryTab {
          height: 60px;
          line-height: 60px;
          box-sizing: border-box;
          border-bottom: 1px solid #e5e5e5;
          span {
            float: left;
            display: inline-block;
            height: 100%;
            width: 140px;
            text-align: center;
            cursor: pointer;
            border-bottom: 2px solid transparent;
          }
          .checkViewFlag {
            border-bottom: 2px solid #1787fb;
          }
        }
        .deliverySucess,
        .beingViewed {
          padding: 12px;
          .companyMsg {
            height: 60px;
            width: 100%;
            overflow: hidden;
            margin-top: 16px;
            border: 1px solid #dde2ea;
            .positions {
              width: 450px;
              height: 100%;
              border-right: 1px dashed #dde2ea;
              padding: 20px 30px 20px 20px;
              box-sizing: border-box;
              .positionsName {
                .fl {
                  font-weight: bold;
                  font-size: 16px;
                  color: #444;
                }
                .fr {
                  font-size: 16px;
                  color: #e77817;
                }
              }
              .positions-detail {
                color: #878787;
                font-size: 14px;
                /* border-bottom: 1px dashed #d4dae4;
								padding: 20px 0; */
                span {
                  display: inline-block;
                  width: 50%;
                }
              }
              .positionsDuties {
                font-size: 14px;
                color: #878787;
                margin-top: 14px;
                i {
                  font-style: normal;
                  display: inline-block;
                  width: 72px;
                }
                span {
                  display: inline-block;
                  width: 290px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
            }
            .companyContent {
              width: 540px;
              height: 100%;
              padding: 20px;
              box-sizing: border-box;
              /*../../assets/images/LOGOThumbnail.png*/
              .companyLogo {
                display: inline-block;
                height: 100%;
                width: 118px;
                img {
                  width: 72px;
                  height: 66px;
                  margin-top: 7px;
                  margin-left: 23px;
                }
              }
              .company {
                display: inline-block;
                width: 410px;
                .companyName {
                  color: #1787fb;
                  i {
                    font-style: normal;
                    font-size: 16px;
                    color: #444444;
                    font-weight: bold;
                  }
                  span {
                    display: inline-block;
                    width: 270px;
                    font-size: 12px;
                    color: #878787;
                  }
                }
                .companyPlace,
                .companyWelfare {
                  color: #444;
                  font-size: 12px;
                  margin: 4px 0;
                }
              }
            }
          }
        }
      }
      .systemMsg {
        height: 120px;
        width: 100%;
        overflow: hidden;
        margin-top: 16px;
        border: 1px solid #dde2ea;
        .sysMsg {
          padding: 10px;
          .contentMsg {
            color: #878787;
            font-size: 13px;
          }
        }
      }
      .systemMsg:hover {
        box-shadow: 0 0 10px #999;
      }

      .changePassword {
        text-align: left;
        padding-top: 52px;
        p {
          width: 428px;
          height: 74px;
          line-height: 74px;
          margin: 0 auto;
          border-bottom: 1px solid #d5dbe5;
          font-size: 16px;
          color: #444;
          box-sizing: border-box;
          input {
            font-size: 16px;
            height: 90%;
            width: 100%;
            outline: none;
            border: none;
          }
        }
        .saveMsg {
          border: none;
          text-align: center;
          span {
            display: inline-block;
            width: 428px;
            height: 52px;
            background-color: #1787fb;
            color: white;
            line-height: 52px;
            margin-top: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1999;
    .saveCommon {
      text-align: center;
      span {
        display: inline-block;
        width: 96px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        color: white;
        background-color: #1787fb;
        cursor: pointer;
        text-align: center;
      }
    }
    .editBasic {
      width: 800px;
      height: 480px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -400px;
      margin-top: -240px;
      background-color: white;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 6px;
      .title {
        width: 100%;
      }
      p {
        height: 40px;
        line-height: 40px;
        width: 50%;
        span {
          display: inline-block;
          width: 124px;
          text-align: right;
          i {
            color: red;
          }
        }
        input[type="text"] {
          height: 30px;
          text-indent: 10px;
          width: 220px !important;
        }
        .iconfont {
          position: absolute;
          display: inline-block;
          width: 36px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          top: 0px;
          cursor: pointer;

          right: 0px;
        }
        select {
          height: 30px;
          text-indent: 10px;
          width: 220px;
          margin-left: -4px;
        }
      }
      .birsday {
        input {
          width: 54px !important;
        }
      }
      .saveCommon {
        width: 100%;
        span {
          text-align: center;
        }
      }
    }
    .edithuntingTitle {
      width: 530px;
      height: 190px;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -265px;
      margin-top: -85px;
      border-radius: 6px;
      padding: 24px;
      color: #444;
      box-sizing: border-box;
      .title {
        font-size: 18px;
      }
      .iconfont {
        position: absolute;
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        top: 0px;
        cursor: pointer;

        right: 0px;
      }
      .check {
        margin: 20px 0;
      }
      label {
        margin-right: 20px;
        cursor: pointer;
      }
    }
    .editDescription {
      width: 530px;
      height: 220px;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -265px;
      margin-top: -110px;
      border-radius: 6px;
      padding: 24px;
      color: #444;
      box-sizing: border-box;
      .title {
        font-size: 18px;
      }
      .iconfont {
        position: absolute;
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        top: 0px;
        cursor: pointer;

        right: 0px;
      }
      .check {
        margin: 20px 0;
      }
    }
    .editWork {
      width: 830px;
      height: 560px;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -415px;
      margin-top: -280px;
      border-radius: 6px;
      padding: 24px;
      color: #444;
      box-sizing: border-box;
      p {
        height: 40px;
        line-height: 40px;
        span {
          display: inline-block;
          width: 100px;
          text-align: center;
        }
        input[type="text"] {
          height: 30px;
          text-indent: 10px;
          width: 220px;
        }
      }
      .comMsg {
        span {
          text-align: right;
        }
      }
      .title {
        font-size: 18px;
        span:first-child {
          width: 200px;
          text-align: left;
        }
      }
      .iconfont {
        position: absolute;
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        top: 0px;
        cursor: pointer;

        right: 0px;
      }
      .kindeditor-component {
        margin: 10px 0;
      }
    }
    .editEdu {
      width: 730px;
      height: 290px;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -265px;
      margin-top: -145px;
      border-radius: 6px;
      padding: 24px;
      color: #444;
      box-sizing: border-box;
      .comMsg {
        height: 40px;
        line-height: 40px;
        margin-top: 6px;
        span {
          display: inline-block;
          width: 100px;
          text-align: center;
        }
        input[type="text"] {
          height: 30px;
          text-indent: 10px;
          width: 220px;
        }
        select {
          height: 30px;
          text-indent: 10px;
          width: 220px;
          margin-left: -5px;
        }
      }
      .title {
        font-size: 18px;
      }
      .iconfont {
        position: absolute;
        display: inline-block;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        top: 0px;
        cursor: pointer;

        right: 0px;
      }
      .saveCommon {
        margin-top: 10px;
      }
    }
  }
  .modify {
    color: #1787fb;
    font-size: 16px;
    font-weight: normal;
    cursor: pointer;
    vertical-align: middle;
    font-style: normal;
    margin-left: 10px;
    .iconfont {
      font-size: 20px;
      margin-right: 4px;
      vertical-align: middle;
    }
  }
  .mx-datepicker {
    width: 224px;
    input {
      border-radius: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/personalCenter.vue